export default __webpack_public_path__ + "static/top2-0831d5bb472fd86391d0958a73d23fa9.svg";